
import { Component, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder} from '@angular/forms';
import { PlanInstitucionalService } from '../../../catalogos-admin/services/plan-institucional.service';

@Component({
  selector: 'app-vision',
  templateUrl: './vision.component.html',
  styleUrls: ['./vision.component.css']
})
export class VisionComponent implements OnInit, OnDestroy {

  breadCrumbItems = [{ label: 'Formulación Planes' }, { label: 'Elementos' }, { label: 'Misón/ Visión', active: true }];
  private currentUser!: any;
  private buffer!: any;



  nameApp = 'MISIÓN Y VISIÓN INSTITUCIONAL';
  public vision: any
  public mision: any

 

  constructor(
    private fb: FormBuilder,
    private planInstitucionalService: PlanInstitucionalService,

  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
  }

  ngOnInit(): void {
    this.planInstitucionalService.list(`?estado=1`).subscribe({
      next:(resp)=>{
        this.vision = resp[0].vision
        this.mision = resp[0].mision
  
      }
    });
  }

  ngOnDestroy(): void {
   // this.dtTrigger.unsubscribe();
  }


}

